import {Injectable} from '@angular/core';

export class ServerMapping {
    public innerContext 						= '/supplyportal-ws-horsa';
    public context;
    // |Variables that just contains all the url paths
    // |Access URLs
    public loginURL 							= this.innerContext + '/access/login';
    public tokenlLoginURL 				        = this.innerContext + '/access/token';
    public profileURL 							= this.innerContext + '/access/profile';
    public logoutURL 							= this.innerContext + '/access/logout';
    public usersURL 							= this.innerContext + '/access/users';
    public resetPasswordURL 					= this.innerContext + '/access/resetPassword';
    public changePasswordURL 					= this.innerContext + '/access/changePassword';

    public configURL                            = this.innerContext + '/configuration/loadtable';
    public customizeURL                         = this.innerContext + '/configuration/loadcustomizing';

    public supplierURL 							= this.innerContext + '/supplier/init';

    public orderSearchURL 						= this.innerContext + '/order/search';
    // |Order URLs
    public orderPrintLabels 					= this.innerContext + '/order/printLabels';
    // |Delivery URLs
    public deliverySearchURL 					= this.innerContext + '/delivery/search';
    public deliveryPrintURL 					= this.innerContext + '/delivery/print';
    // |Material URLs
    public materialSearchURL 					= this.innerContext + '/material/search';
    public materialBomURL                       = this.innerContext + '/material/bom';
    public materialTechnicalSchedeURL           = this.innerContext + '/material/scheda';
    public materialScalareReportURL             = this.innerContext + '/material/scalare';
    public materialScalareExcelReportURL        = this.innerContext + '/material/bomsca-excel';
    public materialArchivioURL                  = this.innerContext + '/material/download';

    // |Stock URLs
    public stockSearchURL 					    = this.innerContext + '/stock/search';
    public stockExportExcelURL 					= this.innerContext + '/stock/excel';
    // |Lot URLs
    public lotSearchURL 					    = this.innerContext + '/lot/search';
    public lotCharacteristicURL 			    = this.innerContext + '/lot/characteristic';
    public lotExcelDownloadURL                  = this.innerContext + '/lot/excel';
    public lotPrintURL                          = this.innerContext + '/lot/print';
    // |Supply Document URLs
    public supplyDocURL                         = this.innerContext + '/document/supplier';
    // |Material Document URLs
    public materialDocURL                       = this.innerContext + '/document/material';
    // |Document Download URLs
    public docDownloadURL                       = this.innerContext + '/document/download';

    constructor() {
        this.context = window.location.pathname;
    }

    getContextPath() {
        return this.context;
    }
}



// WEBPACK FOOTER //
// ./src/app/service/serverMapping.service.ts